import { Box, Button, Divider, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, useTheme } from '@mui/material';
import Modelo3D from './Modelo3D';
import { Delete, RemoveRedEye } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { FileServicesBack, IFileServices } from '../../../services/api/files/FileServicesBack';
import { useParams } from 'react-router-dom';
import { formatDateWhitoutHour } from '../../../services/helpers/helpers';
import { MetaDadosProps, MinioService } from '../../../services/api/minio/Minio';

// interface Planta3DProps {
// 	data: IFileServices[] | null;
// }

export default function Planta3D() {

	const url = useParams();
	const [modelo, setModelo] = useState<string | null>(null);
	const theme = useTheme();
	const [dataFile, setDataFile] = useState<MetaDadosProps[] | null>(null);
	const [file, setFile] = useState<string | null>(null);

	// console.log(file);

	useEffect(() => {
		getFiles(url.dam ?? '');
	}, []);

	async function getFiles(uuid: string) {
		const response = await MinioService.list(uuid);
		if (response instanceof Error) {
			console.log(response);
		} else {
			const data = response.filter((arquivo) => arquivo.tipo == '3d');
			setDataFile(data);
		}
	}

	async function get3D(uuid: string) {
		try {
			const response = await MinioService.getMetadados(uuid);
			if(response instanceof Error){
				console.log(response.message);
			}else{
				if(response.url){
					setFile(response.url);
					setModelo(response.url);
				}
			}
		} catch (error) {
			console.log(error);
		}
	}

	// useEffect(() => {
	// 	setModelo('/teste.glb');
	// }, []);

	console.log(file, 'file');
	console.log(modelo, 'modelo');
	

	return (
		<Box
			display={'flex'}
			flexDirection={'column'}
			gap={2}
		>
			{file &&
				<Box
				height={'30rem'}
				width={'100%'}
				padding={1}
				>
				<Modelo3D
					modelo={file}
				/>
				</Box>
			}
			<Divider />
			<Box width={'100%'} display={'flex'} justifyContent={'end'}>
				{/* <Button variant='contained' onClick={fetchModelo}>Novo +</Button> */}
			</Box>
			{dataFile == null ? (
				<LinearProgress />
			) : (dataFile.length === 0 ? (
				<Typography>Nenhum arquivo 3D cadastrado no sistema</Typography>
			) : (
				<Box
					// border={1}
					// borderColor={theme.palette.primary.contrastText}
					// borderRadius={'5px'}
				>
					<TableContainer sx={{borderRadius: 5}} component={Paper} variant='outlined'>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell>Nome do arquivo</TableCell>
									<TableCell>Data de upload</TableCell>
									<TableCell align='center'>Ação</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{dataFile.map((index) => (
									<TableRow key={index.uuid}>
										<TableCell>{index.nome_arquivo}</TableCell>
										<TableCell>{formatDateWhitoutHour(index.data_registro)}</TableCell>
										<TableCell align='center'>
											<IconButton onClick={() => get3D(index.uuid)}><RemoveRedEye /></IconButton>
											{/* <IconButton><Delete /></IconButton> */}
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>
				</Box>
			))}
		</Box>
	);
}